import { jsx as t } from "react/jsx-runtime";
import { TextPrimitive as o } from "./index.es761.js";
import { forwardRef as m } from "react";
const x = m((e, r) => /* @__PURE__ */ t(o, { ...e, type: "menu", role: "menu-text", ref: r }));
export {
  x as MenuText
};
//# sourceMappingURL=index.es490.js.map
